import { cn } from "@/lib/utils";
import {
    UsersRound,
    Palette,
    Code,
    CircleCheckBig,
    Lightbulb,
    Target,
    BookOpen,
    Layers,
    Zap,
    Flag,
    Star,
    Rocket,
    Info,
    Settings,
    Circle,
    type LucideIcon,
} from "lucide-react";

export const TAB_ICONS: Record<string, LucideIcon> = {
    "users-round": UsersRound,
    palette: Palette,
    code: Code,
    "circle-check-big": CircleCheckBig,
    lightbulb: Lightbulb,
    target: Target,
    "book-open": BookOpen,
    layers: Layers,
    zap: Zap,
    flag: Flag,
    star: Star,
    rocket: Rocket,
    info: Info,
    settings: Settings,
    circle: Circle,
};

export const TAB_ICON_KEYS = Object.keys(TAB_ICONS);

/** Cycle through the curated icons so new tabs get distinct defaults. */
export const defaultTabIcon = (index: number) =>
    TAB_ICON_KEYS[index % TAB_ICON_KEYS.length];

/** Uploaded brand icons are stored as URLs in the same `icon` field as the
 *  built-in keys — anything that looks like a URL is one. */
export const isCustomIcon = (name: string): boolean =>
    name.startsWith("http") || name.startsWith("/");

export function TabIcon({
    name,
    className,
}: {
    name: string;
    className?: string;
}) {
    if (isCustomIcon(name)) {
        // Uploaded PNG/SVG: shown exactly as uploaded, keeping its own colors
        // (built-in icons take the theme color, these do not).
        // eslint-disable-next-line @next/next/no-img-element
        return <img src={name} alt="" className={cn("object-contain", className)} />;
    }
    const Icon = TAB_ICONS[name] ?? Circle;
    return <Icon className={className} />;
}
